export const forwardTransColor = (colors) =>
  colors.map((col) => ({
    sx: {
      bgcolor: col,
    },
  }));

export const reversTransColor = (colors) => colors.map((col) => col.sx.bgcolor);
